module.exports = [{"type":"hash","text":"取消訂閱"},{"type":"normal","text":"取消訂閱的格式如下："},{"type":"code","text":"{ \"id\": \"id1\", \"reqType\": \"unsub\", \"dataType\": \"data to unsub\"}"},{"type":"normal","text":"取消訂閱成功確認："},{"type":"code","text":"{ \"id\": \"id1\", \"code\": 0, \"msg\": \"\" }"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/websocket/introduce/05_cancel_subscribe.json
// module id = 2xEp
// module chunks = 3